import { render, staticRenderFns } from "./IconRam.vue?vue&type=template&id=8f158fa4&scoped=true&"
var script = {}
import style0 from "./IconRam.vue?vue&type=style&index=0&id=8f158fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f158fa4",
  null
  
)

export default component.exports